import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { TelegramFloat } from "./TelegramFloat";
import { WhatsAppFloat } from "./WhatsAppFloat";
import { CookieConsent } from "./CookieConsent";
import { Toaster } from "@/components/ui/sonner";

export const Layout = () => {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Nav />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {/* Floating chat CTAs — Telegram stacks visually ABOVE WhatsApp
          via its own fixed bottom offset. Order in the DOM doesn't matter
          for stacking, but grouping them keeps the file self-documenting. */}
      <TelegramFloat />
      <WhatsAppFloat />
      <CookieConsent />
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
};
